import React from 'react'
import { useSelector } from 'react-redux'

import Anon from '@/components/Anon'
import Dashboard from '@/components/Dashboard'

const AppComponent = () => {
  const layout = useSelector((state: any) => state.layout)
  const user = useSelector((state: any) => state.user)
  const authenticate = useSelector((state: any) => state.authenticate)
  
  let content
  let css_classes_app
  if (authenticate && layout.data && layout.data.departmentId) {
    content = <Dashboard />
    css_classes_app = 'app logged-in'
  } else {
    content = <Anon />
    css_classes_app = 'app not-logged-in'
  }

  return <div className={css_classes_app}>{content}</div>
}

export default AppComponent
